import ListProduct from './ListProduct.jsx';

export {
  ListProduct
}


// WEBPACK FOOTER //
// ./components/list-product/index.js